var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "level" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "title sm-hide" }, [
          _vm._v("\n            资信等级\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "certificate-info" }, [
          _c("img", { attrs: { src: require("./img/certi.png") } }),
          _vm._v(" "),
          _c("div", { staticClass: "level-info" }, [
            _c("div", [_vm._v("三农信评为")]),
            _vm._v(" "),
            _c("div", { staticClass: "level-desc" }, [
              _vm._v("\n                    资信等级AAA企业\n                "),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "content" }, [
              _vm._v(
                "\n                    根据《信用评级业管理暂行办法》和《信贷市场和银行间债券市场信用评级规范》的规定，\n                    中诚信评级机构对我司的信用状况进行了综合分析和评估，经信用评级委员会最后审定，资信等级评为AAA。\n                "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }